<template>
  <div class="content_padding_top_small">
    <div class="signature_field">
      <img v-if="signatureData != 'null' && signatureData != 'N/A'" class="image_layout" :src="signature" height="60">
      <p v-else>N/A</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["signatureData"],
  computed: {
    signature(){
      try {
        let str = '';
        if(this.signatureData % 4 == 1) {
          str = this.signatureData.substring(0, str.length - 1);
        } else {
          str = this.signatureData;
        }
        return window.atob(this.signatureData)
      } catch(err) {
        return this.signatureData;
      }
    }
  }
};
</script>

<style scoped>
@import "../../../styles/custom_alert.css";

.signature {
  background-color: #ffffff;
  border: 3px solid #000000;
}
</style>
